// extracted by mini-css-extract-plugin
export default {"noLeague":"NoLeagueMessage_noLeague__7BHRu"};